// extracted by mini-css-extract-plugin
export default {"container":"skills_container__28asD","skillsContainer":"skills_skillsContainer__0Twtl","skill":"skills_skill__ojg6h"};